export default __webpack_public_path__ + "images/71f9a73ab8c16866f27f812fb708029f.jpg";